export const ON_SELECTED_GRANULARITY_CHANGE = "ON_SELECTED_GRANULARITY_CHANGE";



// WEBPACK FOOTER //
// ./src/store/analytics/chart-granularity/actions.js